module.exports = __webpack_public_path__ + "gs.bfd2809a401e818e0e30.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/gs.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/gs.svg
// module chunks = styles